import * as React from "react";
import * as kea from "kea-react";
import * as models from "app/models/requireme";
import { createSelectorRx } from "keautils";
import { observeResource } from "kea-resource";
import * as resources from "app/resources";
import { FiltroGuiaPP } from "./filtro";

interface Props extends kea.ModalProps<null, string | null, null> {
}

interface State {
    filtro: models.GuiaPPFiltro;
    ClienteReadonly: boolean;
}

const columnasSt: (seleccionar: (folio: string) => void) => kea.Grid2Column<models.GuiaPPDto>[] = sel => [
    {
        title: "Folio Guia",
        cell: x => ({
            data: x.Folio,
            view: () => <kea.Link onClick={() => sel(x.Folio)} >{x.Folio}</kea.Link>
        })
    },/* {
        title: "Gastada",
        cell: x => ({ data: x.Gastada })
    }, {
        title: "Cliente",
        cell: x => ({
            data: x.NombreCliente
        })
    }, {
        title: "Apli. paq.",
        cell: x => ({ data: x.AplicaPaquete })
    }, {
        title: "Apli sobr.",
        cell: x => ({ data: x.AplicaSobre })
    },*/ {
        title: "Importe Flete",
        cell: x => ({ data: x.Importes.Flete })
    }/*,{
        title: "EAD",
        cell: x => ({ data: x.ServiciosAdic.EntregaDomicilio })
    }, {
        title: "RAD",
        cell: x => ({ data: x.ServiciosAdic.RecoleccionDomicilio })
    }*/
    ,{
        title: "Tarifa PP",
        cell: x => ({ data: x.NombreTarifaPP })
    },{
        title: "Cancelada",
        cell: x => ({ data: x.canceladaPP })
    }
];

/**Modal para seleccionar un folio de guía PP */
export class FolioPPModal extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        localStorage['myKey'] = JSON.stringify(props.params);
        var stored = JSON.parse(localStorage['myKey']);

        this.state = {
            filtro: {Gastada : false , IdCliente:  stored.session.IdCliente },
            ClienteReadonly: stored.session.IdCliente != null
        };
        localStorage['myKey'] = '';
    }

    onCerrar = () => this.props.onClose(null);
    onSeleccionar = (x: string) => this.props.onClose(x);

    columnas = columnasSt(this.onSeleccionar);
    filtro = (x: State) => x.filtro;
    params = ( x: Props ) => x.params
    items = createSelectorRx(this.filtro, filtro => observeResource(resources.PaquetePP.QueryGuiasPP, filtro));

    session = createSelectorRx(this.filtro, x => observeResource( resources.PaquetePP.GetSession, x ));

    onFiltroChange = (x: models.GuiaPPFiltro) =>  {

        if ( this.state.filtro.IdCliente ==null && x.IdCliente != null  && this.state.filtro.IdTarifaPP != null) {
            x.IdTarifaPP = null;
        }

        this.setState({ filtro: x });
    }

    render() {
        const items = this.items(this.state);
        const cols = this.columnas;
        const session = this.session( this.state )
        
        return (
            <kea.Modal
                title="Seleccionar folio de PP"
                onClose={this.onCerrar}
            >
                <FiltroGuiaPP ClienteReadonly={this.state.ClienteReadonly} value={this.state.filtro} onChange={this.onFiltroChange}/>
                <kea.Grid2 items={items} columnas={cols} getKey={x => x.IdFolioGuia} />
            </kea.Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guiapp/listado/index.tsx